// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bsb1osq{width:100%}
._4t3i815d{height:calc(100vh - 13pc)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/EmbedModal/components/embed-content/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,UAAU;AACrB,WAAW,yBAAyB","sourcesContent":["._1bsb1osq{width:100%}\n._4t3i815d{height:calc(100vh - 13pc)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
